import { useMutation } from '@apollo/client/react'

import { ATTEND_EVENT } from './useEventActions.mutations'
import { EntityFormResponseInput } from './useEventActions.mutations.generated'

type HandleSubmitProps = {
    state?: 'accept' | 'reject' | 'waitinglist' | 'online' | 'maybe'
    updateSubEvents?: boolean
    formResponse?: EntityFormResponseInput[]
}

const useEventActions = (guid: string) => {
    const [attendEvent, { loading }] = useMutation(ATTEND_EVENT)

    const handleSubmit = async ({
        state = null,
        updateSubEvents = false,
        formResponse = null,
    }: HandleSubmitProps) => {
        try {
            await attendEvent({
                variables: {
                    input: {
                        guid,
                        state,
                        updateSubEvents,
                        formResponse,
                    },
                },
                refetchQueries: [
                    'EventItem',
                    'AttendeesList',
                    'EventItemWithDetailedChildren',
                ],
            })
        } catch (error) {
            console.error(error)
            throw new Error(error) // Rethrow error to be handled by the caller/error boundary
        }
    }

    return { loading, handleSubmit }
}

export default useEventActions
